import { faCircleInfo } from '@fortawesome/pro-light-svg-icons/faCircleInfo'
import { faLockKeyhole } from '@fortawesome/pro-light-svg-icons/faLockKeyhole'
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers'
import { faUserShield } from '@fortawesome/pro-light-svg-icons/faUserShield'

import useTranslation from '@space-core/hooks/useTranslation'
import { ConfigSteps } from '@space-events/toggleUnbanMemberCommunityModal'
import { useUserPermissions } from '@space-shell/common/hooks/useUserPermissions'
import { PermissionActions } from '@space-shell/common/services/communities'

import MenuSection from './menuSection'
import { ContainerMenu, CustomCommunityName } from './styles'
import type { CommunityConfigMenuProps, MenuProps } from './types'

import useCommunityConfigurationSidebar from '../../hooks/useConfigurationCommunitySidebar/useCommunityConfigurationSidebar'

const CommunityConfigMenu = ({ selectedItem, setSelectedItem }: CommunityConfigMenuProps) => {
  const { t } = useTranslation()
  const { hasPermission } = useUserPermissions()

  const { community } = useCommunityConfigurationSidebar()

  const MENU_ITEMS: MenuProps[] = [
    {
      sectionName: t('configuration_sidebar.moderation_section.title'),
      sectionItems: [
        {
          name: t('configuration_sidebar.moderation_section.general'),
          icon: faCircleInfo,
          step: ConfigSteps.GENERAL_CONFIG,
          show: Boolean(community.isOwner)
        },
        {
          name: t('configuration_sidebar.moderation_section.access_and_privacy_item'),
          icon: faLockKeyhole,
          step: ConfigSteps.ACCESS_AND_PRIVACY,
          show: hasPermission(PermissionActions.ACCESS_AND_PRIVACY, community?.permissions?.actions)
        },
        {
          name: t('configuration_sidebar.members_and_permissions.title_v2'),
          icon: faUsers,
          step: ConfigSteps.MEMBERS_AND_PERMISSIONS,
          show: hasPermission(PermissionActions.MEMBER_ROLE_READ, community?.permissions?.actions)
        },
        {
          name: t('modal.ban_list.title'),
          icon: faUserShield,
          step: ConfigSteps.UNBAN_MEBER,
          show: hasPermission(PermissionActions.BLOCK_DELETE, community?.permissions?.actions)
        }
      ]
    }
  ]

  return (
    <ContainerMenu className='_p-5 _d-flex _flex-column _border-right'>
      <h2 className='_text-5 _font-weight-bold _mb-1 _text-gray-900'>
        {t('configuration_sidebar.title')}
      </h2>
      <CustomCommunityName className='_text-1 _font-weight-light _text-gray-500'>
        {community.name}
      </CustomCommunityName>

      {MENU_ITEMS.map((item) => (
        <MenuSection
          sectionName={item.sectionName}
          sectionItems={item.sectionItems}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          community={community}
          key={item.sectionName}
        />
      ))}
    </ContainerMenu>
  )
}

export default CommunityConfigMenu
